import { render, staticRenderFns } from "./AnalysesTab.vue?vue&type=template&id=4061ea87&scoped=true&"
import script from "./AnalysesTab.vue?vue&type=script&lang=js&"
export * from "./AnalysesTab.vue?vue&type=script&lang=js&"
import style0 from "./AnalysesTab.vue?vue&type=style&index=0&id=4061ea87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061ea87",
  null
  
)

export default component.exports